export const CLIENT_LOGOS = [
  { logo: 'https://cdn.bestjobs.eu/employer_logo/58318a882b48e.jpg', name: 'MANPOWER ROMANIA SRL' },
  { logo: 'https://cdn.bestjobs.eu/employer_logo/5c4ebf43565b6.jpg', name: 'OMV Global Solutions' },
  { logo: 'https://cdn.bestjobs.eu/employer_logo/583190a9303b8.jpg', name: 'DB Schenker Global Business Services' },
  { logo: 'https://cdn.bestjobs.eu/employer_logo/58318ad0ee51a.jpg', name: 'MEGA IMAGE S.R.L.' },
  { logo: 'https://cdn.bestjobs.eu/employer_logo/58318abb20e40.jpg', name: 'Orange Romania SA' },
  { logo: 'https://cdn.bestjobs.eu/employer_logo/5839898f77c92.jpg', name: 'SIEMENS SRL' },
  { logo: 'https://cdn.bestjobs.eu/employer_logo/586e298354ed3.jpg', name: 'Societe Generale European Business Services' },
  { logo: 'https://cdn.bestjobs.eu/employer_logo/58318a93a64fa.jpg', name: 'AtoS IT Solutions and Services SRL' },
  { logo: 'https://cdn.bestjobs.eu/employer_logo/5839897c7b82b.jpg', name: 'Huawei Technologies SRL' },
];

export const INCOMPATIBLE_CLIENT_GROUPS = [
  [
    { logo: 'https://cdn.bestjobs.eu/employer_logo/58318a9418d55.jpg', name: 'PepsiCo' },
    { logo: 'https://cdn.bestjobs.eu/employer_logo/5910965738008.png', name: 'Coca-Cola HBC Romania' },
  ],
  [
    { logo: 'https://cdn.bestjobs.eu/employer_logo/5a8c2ea6333fe.gif', name: 'JT International (Romania) S.R.L.' },
    { logo: 'https://cdn.bestjobs.eu/employer_logo/5cf671ff8f730.png', name: 'British American Tobacco Global Business Services' },
  ],
];

const randomIntInclusive = (min: number, max: number) => {
  const minCeil = Math.ceil(min);
  const maxFloor = Math.floor(max);
  return Math.floor(Math.random() * (maxFloor - minCeil + 1)) + minCeil;
};

const shuffleInPlace = <T>(array: T[]) => {
  for (let i = array.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }

  return array;
};

export const getRecruiterLandingLogos = () => {
  const clients = shuffleInPlace([...CLIENT_LOGOS]);
  const incompatibleGroups = INCOMPATIBLE_CLIENT_GROUPS.map((group) => shuffleInPlace([...group]));

  // Insert first group entries
  clients.splice(randomIntInclusive(0, 4), 0, incompatibleGroups[0][0]);
  clients.splice(randomIntInclusive(5, clients.length - 1), 0, incompatibleGroups[0][1]);

  // Insert second group entries
  clients.splice(randomIntInclusive(0, 5), 0, incompatibleGroups[1][0]);
  clients.splice(randomIntInclusive(6, clients.length - 1), 0, incompatibleGroups[1][1]);

  return clients;
};
